const TOKEN_VALUE = localStorage.getItem('token') || ''
export const axiosConfig = {
  headers: {"Content-Type": "application/json", "x-access-token": TOKEN_VALUE}
}
export const axiosConfigFile = {
  headers: {"Content-Type": "multipart/form-data", "x-access-token": TOKEN_VALUE}
}
